import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function PageComunicado() {
	const page = document.querySelector(".page-comunicado");
	if (!page) return;

	revealOnScroll(page);

	page.querySelectorAll("[data-cm-acc]").forEach((item) => {
		const button = item.querySelector("[data-cm-toggle]");
		const panel = item.querySelector(".cm-acc__panel");
		if (!button || !panel) return;

		const sync = () => {
			const open = item.classList.contains("is-open");
			button.setAttribute("aria-expanded", open ? "true" : "false");
			panel.setAttribute("aria-hidden", open ? "false" : "true");
		};

		sync();
		button.addEventListener("click", () => {
			item.classList.toggle("is-open");
			sync();
		});
	});
}

function revealOnScroll(page) {
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const run = () => {
		const mobile = window.matchMedia("(max-width: 767px)").matches;
		const y = mobile ? 18 : 24;
		const duration = mobile ? 0.65 : 0.85;
		const start = mobile ? "top 85%" : "top 82%";
		const line = window.innerHeight * (mobile ? 0.85 : 0.82);

		const blocks = [
			page.querySelector(".cm-nav"),
			page.querySelector(".cm-hero"),
			page.querySelector(".cm-letter .cm-card"),
			page.querySelector(".cm-options__head"),
			...page.querySelectorAll(".cm-choice"),
			page.querySelector(".cm-faq__card"),
			page.querySelector(".cm-contact__card"),
			page.querySelector(".cm-band"),
		].filter(Boolean);

		const visible = [];
		const below = [];

		blocks.forEach((el) => {
			gsap.set(el, { opacity: 0, y });
			if (el.getBoundingClientRect().top < line) visible.push(el);
			else below.push(el);
		});

		if (visible.length) {
			gsap.to(visible, {
				opacity: 1,
				y: 0,
				duration,
				stagger: mobile ? 0.08 : 0.1,
				ease: "power2.out",
				clearProps: "transform",
			});
		}

		below.forEach((el) => {
			ScrollTrigger.create({
				trigger: el,
				start,
				once: true,
				onEnter: () => {
					gsap.to(el, {
						opacity: 1,
						y: 0,
						duration,
						ease: "power2.out",
						clearProps: "transform",
					});
				},
			});
		});

		ScrollTrigger.refresh();
	};

	if (document.body.classList.contains("DOMContentLoaded")) run();
	else {
		const obs = new MutationObserver(() => {
			if (!document.body.classList.contains("DOMContentLoaded")) return;
			obs.disconnect();
			run();
		});
		obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
	}
}
